var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('TheHeader'),_c('TheErrorAlert')],1),_c('main',{staticClass:"mb-5"},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('footer',[_c('TheFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }